module.exports = __webpack_public_path__ + "img/babel.ada62199.png";